/**
 * User Model Instance
 */

define(function(require) {
    'use strict';

    var core = require('core');
    var UserModel = require('modules/user/user.model');

    return UserModel.extend({

        subscribe: function() {
            UserModel.prototype.subscribe.apply(this, arguments);

            this.listenTo(core, 'auth:login', this.loginListener);
        },

        getDefaultPlayerFields: function() {
            var playerFields = UserModel.prototype.getDefaultPlayerFields.apply(this, arguments);

            return playerFields.concat(62, 63, 99, 100, 101, 102);
        },

        loginListener: function() {
            this.fetchUserDetails()
                .then(function() {
                    core.trigger('app:message', {
                        ID: 'ageVerificationStatus'
                    });
                });
        }
    });
});
